<template>
	<div
		type="button"
		:class="['tab', { 'tab--active': active }, { 'tab--button': button }]"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'Tab',
	props: {
		active: {
			type: Boolean,
			default: false
		},
		isDisable: {
			type: Boolean,
			default: false
		},
		button: {
			type: Boolean,
			default: false
		}
	},
	methods: {}
}
</script>

<style scoped lang="scss">
.tab {
	display: flex;
	justify-content: center;
	align-items: center;
	height: $input-field-height;
	border: none;
	background-color: rgba(0, 0, 0, 0);
	color: $colorPrimary5;
	font-size: 18px;
	font-weight: 500;
	cursor: pointer;
	border-bottom: 2px solid rgba(0, 0, 0, 0);

	&--active {
		border-bottom: 2px solid $colorSecondary;
		color: $colorPrimary8;
	}
	&--button {
		border-bottom: 0;
		display: inline-flex;
		appearance: initial;
		-webkit-appearance: initial;
	}

	&.disable {
		cursor: default;
		color: $colorPrimary2;
	}
}
</style>
